// extracted by mini-css-extract-plugin
export default {"cell":"Np5iP4d6Escmypc18zAd"};